import { CardHeader } from "./card-header.js";
import { styles } from "./card-header.styles.js";
import { template } from "./card-header.template.js";
import { DesignSystem } from "../design-system.js";
/**
 *
 * @public
 * @remarks
 * HTML Element: <fabric-card-header>
 */
export const definition = CardHeader.compose({
    name: `${DesignSystem.prefix}-card-header`,
    template,
    styles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=card-header.definition.js.map